// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3Fkmw","emails":"CreateEditClinics_emails__3HCm3","emailTagLabel":"CreateEditClinics_emailTagLabel__2UEwD"};